import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { from, map } from 'rxjs';
import { AiCreditsService } from 'src/app/settings/services/ai-credits.service';

@Component({
  selector: 'ai-credits',
  providers: [DecimalPipe],
  template: `
    <p id="ai-credits" class="tw-font-semibold tw-text-gray-900">
      {{ text() }}
    </p>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiCreditsComponent {
  decimalPipe = inject(DecimalPipe);
  text = toSignal(
    from(this.aiCreditsService.getAICredits()).pipe(
      map((credits) =>
        this.decimalPipe.transform(credits.creditsRemaining, '1.0-0'),
      ),
    ),
  );

  constructor(private aiCreditsService: AiCreditsService) {}
}
